export enum TransactionType {
  Refill = 'refill',
  Withdrawal = 'withdrawal',
  WriteOff = 'write_off',
  Refund = 'refund',
}
